/* =========================================================
   DOPAMEAN — "How we measure" collapsible
   Finds an <h5> inside any .dpm-info-panel whose text matches
   "how we measure" (case-insensitive), and wraps it together
   with every following sibling (up to the next <h5> or end
   of panel) into a <details>/<summary> element so the section
   can be expanded/collapsed. Visual styling is preserved by
   keeping the original h5 element inside <summary>; only a
   small chevron is added on the right via CSS.
   ========================================================= */
(function () {
  var TRIGGER_TEXT = 'how we measure';

  function wrap(panel) {
    var headings = panel.querySelectorAll('h5');
    headings.forEach(function (h5) {
      if (h5.dataset.dpmCollapsibleDone === '1') return;
      var text = (h5.textContent || '').trim().toLowerCase();
      if (text !== TRIGGER_TEXT) return;
      h5.dataset.dpmCollapsibleDone = '1';

      /* Collect every sibling AFTER the h5 up to the next h5 or end. */
      var siblings = [];
      var sib = h5.nextElementSibling;
      while (sib && sib.tagName !== 'H5') {
        siblings.push(sib);
        sib = sib.nextElementSibling;
      }

      /* Build the <details> shell, move the h5 into <summary>, and
         the gathered siblings into a content wrapper. */
      var details = document.createElement('details');
      details.className = 'dpm-info-collapsible';
      var summary = document.createElement('summary');
      summary.className = 'dpm-info-collapsible__summary';
      h5.parentNode.insertBefore(details, h5);
      summary.appendChild(h5);
      details.appendChild(summary);

      var content = document.createElement('div');
      content.className = 'dpm-info-collapsible__content';
      siblings.forEach(function (el) { content.appendChild(el); });
      details.appendChild(content);
    });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.dpm-info-panel, .dpm-info-story').forEach(wrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) init(e.target);
  });

  /* Re-run when product-info swaps content (variant change). */
  if (typeof MutationObserver !== 'undefined') {
    document.querySelectorAll('product-info').forEach(function (pi) {
      new MutationObserver(function () { init(pi); }).observe(pi, {
        childList: true,
        subtree: true,
      });
    });
  }
})();
